import { render, staticRenderFns } from "./ajustage.pug?vue&type=template&id=a57c0eda&lang=pug&"
import script from "./ajustage.js?vue&type=script&lang=js&"
export * from "./ajustage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a57c0eda')) {
      api.createRecord('a57c0eda', component.options)
    } else {
      api.reload('a57c0eda', component.options)
    }
    module.hot.accept("./ajustage.pug?vue&type=template&id=a57c0eda&lang=pug&", function () {
      api.rerender('a57c0eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/views/ajustage/index.vue"
export default component.exports